import { useRouteMatch } from 'react-router-dom';
import { COURSE_OVERVIEW_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT, SHORT_OVERVIEW_URL_FRAGMENT } from '../../constants/Navigation';
export const useIsOverviewOpen = () => {
  const isTrackOverview = useRouteMatch(COURSE_OVERVIEW_URL_FRAGMENT);
  const isLessonOverview = useRouteMatch(LESSON_OVERVIEW_URL_FRAGMENT);
  const isShortOverview = useRouteMatch(SHORT_OVERVIEW_URL_FRAGMENT);
  return isTrackOverview || isLessonOverview || isShortOverview;
};